<div class="p-2 flex flex-col gap-2 ml-2 offset-left-tooltip">
  @if (componentType() === 'dialog') {
    <div class="flex justify-between items-center">
      <p class="subtitle-2">
        {{ 'outlook.sync.install.title' | translate }}
      </p>
      <button
        id="outlook-sync-ui-settings-closeIcon"
        kendoButton
        fillMode="flat"
        iconClass="fa-icons icon-xmark icon-14"
        [attr.aria-label]="'outlook.buttons.close' | translate"
        (click)="openInstallSync.emit(false)"
        class="small"
      ></button>
    </div>
  } @else {
    <p class="subtitle-2">
      {{ 'outlook.sync.install.title' | translate }}
    </p>
  }
  <p class="text-body">
    {{ 'outlook.sync.install.installation' | translate }}
  </p>
  <p
    class="text-body"
    [innerHtml]="'outlook.sync.install.installationNote' | translate"
  ></p>
  <div class="flex justify-end">
    <button kendoButton themeColor="primary" (click)="installOutlookSync()">
      {{ 'outlook.buttons.install' | translate }}
    </button>
  </div>
</div>

<maximizer-outlook-notification #notification [closable]="true">
</maximizer-outlook-notification>
